<template>
  <Frame>
    <PageHeader :title="$t('comm.pubPriceQuery')" :hasBack="false"/>
    <div class="list-contain">
      <div class="head-contain">
        <div class="filter-contain">
          <span style="min-width: 56px;">{{ $t('pubPriceQuery.type') }}</span>
          <el-select v-model="typeValue" placeholder="" class="typeSel" size="small">
            <el-option
              v-for="item in typeSel"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>

        <div class="filter-contain">
          <span>{{ $t('pubPriceQuery.basZipId') }}</span>
          <el-input v-model="basZipId" :placeholder="$t('salSalesOrder.inputpls')" size="small" clearable></el-input>
        </div>

        <div class="filter-contain">
          <span>{{ $t('pubPriceQuery.pullHeadId') }}</span>
          <el-input v-model="pullHeadId" :placeholder="$t('salSalesOrder.inputpls')" size="small" clearable></el-input>
        </div>

        <div class="filter-contain">
          <span>{{ $t('pubPriceQuery.faceId') }}</span>
          <el-input v-model="faceId" :placeholder="$t('salSalesOrder.inputpls')" size="small" clearable></el-input>
        </div>

        <div class="filter-contain">
          <span style="min-width: 56px;">{{ $t('pubPriceQuery.supplier') }}：</span>
          <el-input v-model="supplierId" :placeholder="$t('salSalesOrder.inputpls')" size="small" clearable></el-input>
        </div>

        <div class="filter-contain">
          <span>{{ $t('pubPriceQuery.specId') }}</span>
          <el-input v-model="specId" :placeholder="$t('salSalesOrder.inputpls')" size="small" clearable></el-input>
        </div>
        <div style="width:49%;">
          <span style="width: 100%;display: flex; justify-content: flex-end;">
            <el-button type="reset" @click="reset()">{{ $t('button.reset') }}</el-button>
            <el-button type="primary" @click="GetListData(0)">{{ $t('button.query') }}</el-button>
        </span>
        </div>
      </div>
    </div>
    <el-table ref="multipleTable" :data="tableData" :height="tableHeight" style="margin:0;width:100%" v-loading="tableLoading">
      <el-table-column :min-width="WidthControl('BizPartnerId',tableData)" prop="BizPartnerId" :label="$t('pubPriceQuery.supplier')"></el-table-column>
      <el-table-column :min-width="WidthControl('BasZipId',tableData)" prop="BasZipId" :label="$t('pubPriceQuery.basZipCode')"></el-table-column>
      <el-table-column :min-width="WidthControl('BasZipName',tableData)" prop="BasZipName" :label="$t('pubPriceQuery.basZipName')"></el-table-column>
      <el-table-column :min-width="WidthControl('PullHeadId',tableData)"  prop="PullHeadId" :label="$t('pubPriceQuery.pullHeadCode')" v-if="this.showType=='0002'"></el-table-column>
      <el-table-column :min-width="WidthControl('FaceId',tableData)" prop="FaceId" :label="$t('pubPriceQuery.faceCode')" v-if="this.showType=='0003'"></el-table-column>
      <el-table-column :min-width="WidthControl('SpecId',tableData)" prop="SpecId" :label="$t('pubPriceQuery.specCode')" v-if="this.showType=='0004'"></el-table-column>
      <el-table-column :min-width="WidthControl('SpecName',tableData)"  prop="SpecName" :label="$t('pubPriceQuery.specName')" v-if="this.showType=='0004'"></el-table-column>
      <el-table-column :min-width="WidthControl('RLengths',tableData)"  prop="RLengths" :label="$t('pubPriceQuery.rLengths')" v-if="this.showType=='0001'" align="right"></el-table-column>
      <el-table-column :min-width="WidthControl('LUnitId',tableData)" prop="LUnitId" :label="$t('pubPriceQuery.lUnitId')" v-if="this.showType=='0001'" align="right"></el-table-column>
      <el-table-column :min-width="WidthControl('NoTaxPrice',tableData)" prop="NoTaxPrice" :label="$t('pubPriceQuery.noTaxPrice')"></el-table-column>
      <el-table-column :min-width="WidthControl('LnchPrice',tableData)"  prop="LnchPrice" :label="$t('pubPriceQuery.lnchPrice')" v-if="this.showType=='0001'"></el-table-column>
    </el-table>
    <div class="footer-contain">
      <PageSizeChanger :pagesize="pageSize" :afterChange="pageSizeChange"></PageSizeChanger>
      <el-pagination ref="pagination" class="pagination" @current-change="handleCurrentChange" layout="total,prev,pager,next,jumper" :pager-count="pagecount" :current-page="currentPage" :total="totalCount" :page-size="pageSize"
      ></el-pagination>
    </div>
  </Frame>
</template>
<script>
import { listMixin } from '@/agency/mixin/mixin.js'
export default {
  name: "PubPriceQuery",
  mixins: [listMixin],
  data() {
    return {
      typeSel: [
        {
          value: "0001",
          label: this.$t("pubPriceQuery.basZipName")
        },
        {
          value: "0002",
          label: this.$t("pubPriceQuery.typeSel2")
        },
        {
          value: "0003",
          label: this.$t("pubPriceQuery.typeSel3")
        },
        {
          value: "0004",
          label: this.$t("pubPriceQuery.specName")
        }
      ],
      typeValue: "0001",
      basZipId: "",//过滤条件
      pullHeadId: "",
      supplierId: "", 
      faceId: "",
      specId: "",
      tableData: [], //当前页数据
      showType:"0001",
      pageIndex: 0,
      totalCount: 0,
      tableLoading: false,
      resizeFlag: null,
      tableHeight: window.innerHeight - 310,
      pagecount: 5,
    };
  },
  props: {
    GetListData: {
      type: Function,
      default: function(pageIndex, ...arg) {
        this.getListData(pageIndex, ...arg);
      }
    }
  },
  mounted() {
    this.frameOnResize(310);
  },
  created() {
    //this.GetListData(this.pageIndex);
  },
  methods: {
    getListData(index) {
      this.pageIndex = index;
      var errorMsg="";
      switch (this.typeValue) {
           case "0001":
           if (this.basZipId == "") {
               errorMsg = this.$t("pubPriceQuery.basZipWarn");
            }
            break;
            case "0002":
            if (this.basZipId == "" || this.pullHeadId == "") {
                errorMsg = this.$t("pubPriceQuery.pullWarn");
            }
            break;
            case "0003":
            if (this.basZipId == "" || this.faceId == "") {
                errorMsg = this.$t("pubPriceQuery.faceWarn");
            }
            break;
            case "0004":
            if (this.basZipId == "" || this.specId == "") {
                errorMsg = this.$t("pubPriceQuery.specWarn");
            }
            break;
      }
      if (errorMsg!="") { 
          this.$alert(errorMsg, this.$t("comm.tip"));
          return;
      }
      var ymAy = new Array();
      ymAy.push(this.setAyList("A.BizAttr", this.typeValue));
      ymAy.push(this.setAyList("B.BasZipId", this.basZipId));
      ymAy.push(this.setAyList("B.PullHeadId", this.pullHeadId));
      ymAy.push(this.setAyList("B.FaceId", this.faceId));
      ymAy.push(this.setAyList("B.SpecId", this.specId));
      ymAy.push(this.setAyList("A.BizPartnerId", this.supplierId));
      this.tableLoading = true;
      this.axiosInvoke(this.YMBillHandlerUrl,{
          action: "pubpricequery",
          ymAy: JSON.stringify(ymAy),
          pageIndex: this.pageIndex,
          pageSize: this.$store.state.pagesize
        },(res) => {
          const data = res.data;
          this.showType=this.typeValue;
          this.tableLoading = false;
          this.tableData = data.DataTable ? data.DataTable : [];
          this.totalCount = data.totalCount;
        },false,true);
    }, 
    setAyList(fieldName, fieldNameVal) {
      var tempAy = new Array();
      //将参数添加到数组
      tempAy.push([
        { name: fieldName },
        { value: fieldNameVal }
     ]);
     return tempAy[0];
    },
    handleCurrentChange(page) {
      this.pageIndex = page - 1;
      this.GetListData(this.pageIndex);
    },
    pageSizeChange() {
      this.GetListData(0);
    },
    reset() {
      this.typeValue = "0001";
      this.basZipId = "";
      this.pullHeadId = "";
      this.supplierId = "";
      this.faceId = "";
      this.specId = "";
      this.tableData = [];
      this.showType ="0001",
      this.pageIndex = 0;
      this.totalCount = 0;
    },
  }
};
</script>
<style scoped>
.list-contain {
  display: flex;
  padding: 10px 0px;
}
.head-contain {
  padding: 0 20px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}
.filter-contain {
  width: 24%;
  padding-right: 1%;
  display: flex;
  flex-wrap: nowrap;
  padding-bottom: 10px;
}
.filter-contain > span {
  color: #5d5d5d;
  font-size: 14px;
  margin: auto;
  white-space: nowrap;
}
.head-contain > div >span > .el-button{
  padding: 10px 18px;
}
.el-date-editor.el-input,.el-date-editor.el-input__inner,.el-input-number,.typeSel {
  width: 100%;
}
.el-table /deep/ .el-table__header .cell .el-checkbox:first-child {
  padding-left: 5px;
}
.footer-contain {
  display: flex;
  padding-top: 6px;
  justify-content: center;
}
.pagination {
  padding-top: 4px;
}
.el-table{
  font-size: 12px;
}
.el-table /deep/ th.el-table__cell {
  background-color: #f9f9f9;
}
.el-table /deep/ thead {
  font-size: 14px;
  color: #5d5d5d;
}
.el-dialog__wrapper /deep/ .el-dialog .el-dialog__body{
  text-align: center;
}
</style>
